import { extend } from "vee-validate"
import * as rules from 'vee-validate/dist/rules'

for (let [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation
  })
}
extend('emailMethod', {
  validate(value) {
    return /^[a-zA-Zа-яА-ЯяёЁЇїІіЄєҐґ0-9_.-]+@[a-zA-Zа-яА-ЯяёЁЇїІіЄєҐґ0-9_.-]+\.[a-zA-Zа-яА-ЯяёЁЇїІіЄєҐґ]{2,6}$/.test(value)
  }
})
extend('username', {
  validate(value) {
    return /^[a-zA-Zа-яА-ЯяёЁЇїІіЄєҐґ ’'-]+$/i.test(value)
  }
})
extend('phoneNumber', {
  validate(value) {
    const phoneLength = 12
    return phoneLength == value.replace(/\D/g, "").toString().length
  }
})

extend('confirmed', {
  ...rules.confirmed,
  message() {
    return 'The values do not match.'
  },
})

extend('ukPhone', {
  validate(value) {
    const PHONE_REGEXP = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/
    return PHONE_REGEXP.test(value)
  }
})

extend('oneHour', {
  validate(value, args) {
    const [date] = args
    if (!value.length || !date.length) return false
    let userDate = new Date(date)
    let currentDate = new Date()
    if (userDate.toDateString() === currentDate.toDateString()) {
      const step1 = 60,
        step2 = 1000
      const ONE_HOUR = step1 * step1 * step2
      const [hour, min] = value.split(':')
      let nowDate = new Date()
      const userTime = nowDate.setHours(parseInt(hour), parseInt(min))
      const anHourAgo = Date.now() + ONE_HOUR
      return userTime > anHourAgo
    }
    return true
  },
})



// WEBPACK FOOTER //
// ./src/js/validation/extends.js